import Vue from 'vue';
import App from './App.vue';
import storage from './model/storage.js';
import api from './model/config.js';

//请求数据配置
import VueResource from 'vue-resource';
Vue.use(VueResource);


//获取url传过来的桌号  保存桌号

// console.log(window.location.hash.split('=')[1]);
//location.hash则可以用来获取或设置页面的标签值，split 方法结合循环遍历自由组织数据格式，
//JS 脚本捕获页面 GET 方式请求的参数，从井号 (#) 开始的 URL（锚）
/**
*window.location.hash 定义和用法
*location是javascript里边管理地址栏的内置对象.
*比如location.href就管理页面的url，用location.href=url就可以直接将页面重定向url。
*而location.hash则可以用来获取或设置页面的标签值。比如http://domain/#admin的location.hash="#admin"。
*
*substr 定义和用法
*substr() 方法可在字符串中抽取从 start 下标开始的指定数目的字符。
*语法 stringObject.substr(start,length)
*start 必需。要抽取的子串的起始下标。必须是数值。如果是负数，那么该参数声明从字符串的尾部开始算起的位置。
*也就是说，-1 指字符串中最后一个字符，-2 指倒数第二个字符，以此类推。
*length 可选。子串中的字符数。必须是数值。如果省略了该参数，那么返回从 stringObject 的开始位置到结尾的字串。
* 学习参考：https://www.cnblogs.com/wdlhao/p/4916628.html
* 示例代码如下：
* var shash = window.location.hash.substr(1);
var params = shash.split('&');
var map = new HashMap();
for (var i in params) {
var p = params[i].split("=");
if (p.length == 2) {
map.put(p[0], p[1]);
}
}
num_iid = map.get('iid');
detailstate = map.get('state');
if(detailstate =='chuc' || detailstate == 'chus' || detailstate == 'cangk' || detailstate == 'shouw'){
$('#deatailback').show();
}
page = map.get('page');
*/
var roomid = window.location.hash.split('=')[1];

//szy add,下面的代码没反应，只能改成4位uid
//var ilen =roomid.length;
//if (uid.substring(ilen-1,ilen)=='&') {
//       uid = uid.substring(0,3);
//    };

roomid=roomid.substring(0,4);//PC和手机浏览器扫码没问题，支付宝扫码也没问题，但微信扫码后，尾缀的房号后面增加了“&nsukey”,导致识别房号出错。
//例如：http://localhost:8001/#/home?roomid=a001,取=右边的值，
//说明：hash在微信浏览器中不能正确识别出=后面的字符，而加上了尾缀字母&h&h等。这个是浏览器兼容的问题
//解决方法：window.location.toString().split('=')[1] // car=Town%20%26%20Country
//参考：https://codeday.me/bug/20190515/1108209.html

//szy add：截取到房号或桌号后，要判断是否正确，防止人为改为错误的房号，中间件中有getUid的接口路由
//以下由SZY ADD START

//szy说明：此处的api/getUid中的api是有VUE过滤掉的。实际url是没有的。只是前端和中间件的两个文件中约定的路由头
//export default {
 /* function getUid() {

    var api1 = api.api + 'api/getUid?uid=' + roomid;

    VueResource.http.get(api1).then((response) => { //注意：前端get,中间件必须是get;而且get和post的格式不一样
      console.log(response);

      if (response.body.result.length > 0) {
        return response.body.result.length;
      };

      if (response.body.success) { //返回为TRUE，说明房号存在，可以继续下面的操作
        return response.body.result.length;
      }

    }, (error) => {
      console.log(error);
      //alert("uid数据非法");
      return 0; //退出JS文件，不执行后面的语句
    });
//  }
};

var len = getUid();
if (len == 0) {
  alert("uid数据非法");
   //退出JS文件，不执行后面的语句
};
*/

//以下由SZY ADD END
//localStorage
//storage.clear();//此办法解决微信乱码，就是使用不方便
//storage.set('roomid', roomid); //临时存储该房号，以备后面自己或别人访问时用
storage.set('roomid', roomid); //临时存储该房号，以备后面自己或别人访问时用

//cookie:
//storage.setCookie('roomid',roomid,7);

////////////////////////////////////
import VueSocketio from 'vue-socket.io';
//Vue.use(VueSocketio, 'http://a.itying.com?roomid='+roomid);
//Vue.use(VueSocketio, 'http://192.168.11.2:8001?roomid='+roomid);//自己的笔记本IP，供手机访问
Vue.use(VueSocketio, api.api2 + '?roomid=' + roomid);

//vue-socket.io的使用步骤


/*

1、安装npm install vue-socket.io --save


2、main.js 引入  并且use

  import VueSocketio from 'vue-socket.io';
  Vue.use(VueSocketio, 'http://a.itying.com');

3、vue实例里面定义sockets，sockets里面的方法表示接收到服务器的消息以后触发

  sockets:{
      connect: function(){
        console.log('socket connected')
      },
      customEmit: function(val){
        console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
      }
    }


4、给服务器发数据

    this.$socket.emit('emit_method', val);


*/




//0、如果在一个模块化工程中使用它，必须要通过 Vue.use() 明确地安装路由功能，安装引入路由  use路由
//官方：https://router.vuejs.org/zh/guide/#html
//import Vue from 'vue'//是公共的，改在第一行显示了
import VueRouter from 'vue-router';
Vue.use(VueRouter);

//1、创建引入组件

import Start from './components/Start.vue';
import Home from './components/Home.vue';
import Hot from './components/Hot.vue';
import Order from './components/Order.vue';
import Pcontent from './components/Pcontent.vue';
import Search from './components/Search.vue';
import Cart from './components/Cart.vue';
import EditPeopleInfo from './components/EditPeopleInfo.vue';

//2、配置组件对应的路由名称
//（SZY ADD:为什么要做得这么麻烦？直接引用相对路径下的组件.vue文件名不好吗？那是因为必须由VUE将.vue组件解析为正常浏览器能识别的.js文件。）

const routes = [{
    path: '/start',
    component: Start
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/hot',
    component: Hot
  },
  {
    path: '/order',
    component: Order
  },
  {
    path: '/pcontent',
    component: Pcontent
  },
  {
    path: '/search',
    component: Search
  },
  {
    path: '/cart',
    component: Cart
  },
  {
    path: '/editpeopleinfo',
    component: EditPeopleInfo
  },
  {
    path: '*',
    redirect: '/start'
  }
]

//3、实例化VueRouter

const router = new VueRouter({
  routes // （缩写）相当于 routes: routes  属性的简写
})

//4、挂载

new Vue({
  el: '#app',
  router,
  sockets: { /*测试期间写 也不不写在根里面*/
    connect: function() {
      console.log('socket connected')
    },

  },

  render: h => h(App)
})

//5、需要 <router-view></router-view>  放在根组件App.vue里面
//<!-- 路由出口 -->
// <!-- 路由匹配到的组件将渲染在这里 -->



// WEBPACK FOOTER //
// ./src/main.js